var _defs, _g, _g2, _g3, _path, _g4, _g5, _g6, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 370,
    viewBox: "0 0 277.5 416.99999",
    height: 556,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.199219 179.359375h78.75v59.25h-78.75Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.199219 203H142v26H99.199219Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135 207h42.949219v25H135Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.199219 179.953125h78.75v59.25h-78.75Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.199219 204H142v25H99.199219Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135 207h42.949219v25H135Zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M101.808594 236.140625h73.523437v-54.3125h-73.523437Zm74.746094 2.46875h-75.96875c-.679688 0-1.226563-.550781-1.226563-1.234375v-56.78125c0-.683594.546875-1.234375 1.226563-1.234375h75.96875c.675781 0 1.226562.550781 1.226562 1.234375V237.375c0 .683594-.550781 1.234375-1.226562 1.234375"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M100.585938 228.019531c-.308594 0-.617188-.117187-.855469-.351562-.484375-.476563-.496094-1.257813-.023438-1.746094l21.261719-21.992187c.230469-.238282.546875-.371094.875-.371094.332031 0 .648438.132812.878906.371094l18.851563 19.5c.472656.488281.460937 1.269531-.023438 1.746093-.484375.476563-1.257812.464844-1.730469-.023437L121.84375 206.5625l-20.382812 21.082031c-.238282.25-.558594.375-.875.375"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M176.554688 231.242188c-.316407 0-.636719-.125-.875-.375l-19.816407-20.496094-14.289062 14.78125-3.914063 4.046875c-.472656.488281-1.246094.5-1.730468.023437-.484376-.476562-.496094-1.257812-.023438-1.746094l3.914062-4.046874 15.164063-15.6875c.230469-.238282.546875-.375.878906-.375.328125 0 .644531.136718.875.375l20.695313 21.402343c.472656.488281.460937 1.269531-.023438 1.746094-.238281.234375-.546875.351563-.855468.351563"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M144.996094 191.371094c-2.691406 0-4.878906 2.207031-4.878906 4.921875 0 2.710937 2.1875 4.917969 4.878906 4.917969 2.691406 0 4.878906-2.207032 4.878906-4.917969 0-2.714844-2.1875-4.921875-4.878906-4.921875Zm0 12.3125c-4.042969 0-7.332032-3.316406-7.332032-7.390625 0-4.074219 3.289063-7.390625 7.332032-7.390625 4.042968 0 7.328125 3.316406 7.328125 7.390625 0 4.074219-3.285157 7.390625-7.328125 7.390625"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M101.808594 236.734375h73.523437v-54.3125h-73.523437Zm74.746094 2.46875h-75.96875c-.679688 0-1.226563-.550781-1.226563-1.234375V181.1875c0-.683594.546875-1.234375 1.226563-1.234375h75.96875c.675781 0 1.226562.550781 1.226562 1.234375v56.78125c0 .683594-.550781 1.234375-1.226562 1.234375"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M100.585938 228.613281c-.308594 0-.617188-.117187-.855469-.351562-.484375-.476563-.496094-1.257813-.023438-1.746094l21.261719-21.992187c.230469-.238282.546875-.371094.875-.371094.332031 0 .648438.132812.878906.371094l18.851563 19.5c.472656.488281.460937 1.269531-.023438 1.746093-.484375.476563-1.257812.464844-1.730469-.023437L121.84375 207.15625l-20.382812 21.082031c-.238282.25-.558594.375-.875.375"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M176.554688 231.835938c-.316407 0-.636719-.125-.875-.371094l-19.816407-20.496094-14.289062 14.777344-3.914063 4.046875c-.472656.488281-1.246094.5-1.730468.023437-.484376-.476562-.496094-1.257812-.023438-1.746094l3.914062-4.046874 15.164063-15.6875c.230469-.238282.546875-.375.878906-.375.328125 0 .644531.136718.875.375l20.695313 21.402343c.472656.488281.460937 1.269531-.023438 1.746094-.238281.234375-.546875.351563-.855468.351563"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M144.996094 191.964844c-2.691406 0-4.878906 2.207031-4.878906 4.921875 0 2.710937 2.1875 4.917969 4.878906 4.917969 2.691406 0 4.878906-2.207032 4.878906-4.917969 0-2.714844-2.1875-4.921875-4.878906-4.921875Zm0 12.3125c-4.042969 0-7.332032-3.316406-7.332032-7.390625 0-4.074219 3.289063-7.390625 7.332032-7.390625 4.042968 0 7.328125 3.316406 7.328125 7.390625 0 4.074219-3.285157 7.390625-7.328125 7.390625"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCard);
export default __webpack_public_path__ + "static/media/EmptyCard.82427e86b72979c60e4e5bce792b9c52.svg";
export { ForwardRef as ReactComponent };